import React, { Component } from 'react';
import HorizontalTimelineContent from './HorizontalTimelineContent';
import GameInfo from './content';
import { isWebP } from '../../utils';
import './timeline-container.scss';

class TimelineContainer extends Component {
  constructor(props) {
    super(props);
    this.state = { value: 0, previous: 0 };
  }

  componentWillMount() {
    const isWebPAllowed = isWebP() ? true: false;
    this.data = GameInfo.map((game, index) => {
      return {
        date: game.date,
        component: (
          <div
            id="timeline"
            className="container timeline-container"
            key={index}
          >
            <div className="title-container">
              <div className="logo-container">
                {game.flags
                .split(',')
                .map((flag, i) => {
                  let flagClass = isWebPAllowed ? `${flag}-webp`: `${flag}-jpg`;
                  return (
                    <div key={i} className={`company-logo ${flagClass}`}/>)
                })}
              </div>
              <div className="subtitle">
                <h4>{game.subtitle}</h4>
              </div>                       
            </div>
            <div className="content-container">
              <p>{game.content}</p>
            </div>
            <div className="tech-container">
                {game.technologies
                .split(',')
                .map((tech, i) => <div key={i} className="tech">{tech}</div>)}
              </div>
          </div>
        ),
      };
    });
  }

  render() {
    return (
      <section id="professional-timeline" className="professional-timeline">
        <HorizontalTimelineContent content={this.data} />
      </section>
    );
  }
}

export default TimelineContainer;



// WEBPACK FOOTER //
// ./src/components/Timeline/TimelineContainer.js